import { TLkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';

export const INITIAL_LK_TYPE_STATE: TLkType | null = null;

export const lkTypeReducer = (state: TLkType | null = INITIAL_LK_TYPE_STATE) => state;
